














































import { EmptyPagedResults, infiniteLoad, PagingParams } from "@abaco/web-common/src/Paging";
import { Debounce } from "vue-debounce-decorator";
import { TranslateResult } from "vue-i18n";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import MaltaModule, { MODULE_ID } from "../../index";
import { Person, Persons } from "../../models/Decoding";

@Component
export default class PersonsListModal extends Vue {
    @Inject(MODULE_ID) maltaModule!: MaltaModule;
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
    @Prop({ type: Object, default: null }) value!: Person | null;
    @Prop({ type: String, required: true }) subjectId!: string;
    @Prop({ type: String, required: true }) applicationId!: string;
    show = false;
    loading = true;
    data: Persons = new EmptyPagedResults();
    identifier = 1;
    search = "";

    openHandler(): void {
        this.show = true;
    }

    closeHandler(): void {
        this.show = false;
        this.$emit("close");
    }

    @Watch("search")
    @Debounce(500)
    onSearch() {
        this.data = new EmptyPagedResults();
        this.identifier++;
    }

    onSelect(index: number): void {
        const data = this.data.records[index] ?? null;
        this.$emit("input", data);
        this.show = false;
    }

    async loadNextPage(): Promise<boolean> {
        const newPage = await infiniteLoad(
            (paging: PagingParams) =>
                this.maltaModule.decodingApi.getPerson(this.subjectId, this.applicationId, this.search, paging),
            this.data
        );
        if (newPage) {
            this.data = newPage;
            return true;
        }
        return false;
    }
}
